module.exports = __webpack_public_path__ + "static/media/ucd.08e016ed.png";